import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { axisBottom, axisLeft } from 'd3-axis';

import { max } from 'd3-array';
import { scaleLinear } from 'd3-scale';
import { select } from 'd3-selection';

import widgetWrapper from './widgetWrapper';

import './TimelineScatterplotWidget.scss';

const WIDTH = 500;
const HEIGHT = 300;
const PADDING = 30;

// const NUM_POINTS = 200;
// const maxRange = () => 1000 * Math.random();

class TimelineScatterplotWidget extends Component {

  constructor(...args) {
    super(...args);
    this.xAxisRef = React.createRef();
    this.yAxisRef = React.createRef();
  }

  componentDidMount() {
    this.renderAxes();
  }

  componentDidUpdate() {
    this.renderAxes();
  }

  generateScales() {
    const xMax = max(this.props.series, d => d[0]);
    const yMax = max(this.props.series, d => d[1]);
    const xScale = scaleLinear().domain([0, xMax]).range([PADDING, WIDTH - 2 * PADDING]);
    const yScale = scaleLinear().domain([0, yMax]).range([HEIGHT - PADDING, PADDING]);
    return [xScale, yScale];
  }

  renderAxes() {
    const [xScale, yScale] = this.generateScales();
    const xNode = this.xAxisRef.current;
    const yNode = this.yAxisRef.current;

    const xAxis = axisBottom(xScale).ticks(5);
    select(xNode).call(xAxis);
    const yAxis = axisLeft(yScale).ticks(5);
    select(yNode).call(yAxis);
  }

  render() {
    const [xScale, yScale] = this.generateScales();
    return (
      <svg width={WIDTH} height={HEIGHT}>
        <g>
          {(this.props.series.map(coords => (
            <circle
              cx={xScale(coords[0])}
              cy={yScale(coords[1])}
              r={5}
              key={coords.join(',')}
              fill="white"
            />
          )))}
        </g>
        <g className="xy-axis">
          <g
            className="axis"
            ref={this.xAxisRef}
            transform={`translate(0, ${HEIGHT - PADDING})`}
          />
          <g
            className="axis"
            ref={this.yAxisRef}
            transform={`translate(${PADDING}, 0)`}
          />
        </g>
      </svg>
    );
  }
}

TimelineScatterplotWidget.propTypes = { series: PropTypes.arrayOf(PropTypes.object) };

TimelineScatterplotWidget.defaultProps = {
  series: [],
};

export default widgetWrapper(TimelineScatterplotWidget);
